import React from "react";
import "../../styles/Home.css";

const facts = [
  {
    icon: "fas fa-home",
    title: "Start with a budget",
    fact: "Describe the work to explore an indicative estimate. Your confirmed measurements, materials and scope help shape the budget.",
    featured: true,
  },
  {
    icon: "fas fa-piggy-bank",
    title: "Compare written quotes",
    fact: "Ask tradespeople for written quotes covering the same work, materials and VAT, then compare what is included.",
  },
  {
    icon: "fas fa-clock",
    title: "Build a clearer brief",
    fact: "Percy's follow-up questions help you clarify the job before you contact a tradesperson.",
  },
  {
    icon: "fas fa-user-shield",
    title: "Check before you book",
    fact: "Review the available profile evidence, check references and credentials, and agree the work and payment terms in writing.",
  },
];

const DidYouKnow = () => (
  <div className="section did-you-know">
    <h2 className="section-title">Plan before you book</h2>
    <div className="facts-container bento">
      {facts.map((item, index) => (
        <div
          key={index}
          className={`fact-card ${item.featured ? "bento-featured" : "bento-stat"}`}
        >
          <div className="fact-accent-bar"></div>
          <div>
            <h3 className="fact-title">{item.title}</h3>
            <p className="fact-description">{item.fact}</p>
          </div>
        </div>
      ))}
    </div>
  </div>
);

export default DidYouKnow;
